import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Container, Typography, Button } from '@mui/material';
import { CustomAppBar } from '@virtual-cinema/client-lib';

function NotFoundPage() {
    const navigate = useNavigate();

    return (
        <Container maxWidth="xl">
            <Box sx={{ flexGrow: 1, bgcolor: 'background.default', color: 'text.primary' }}>
                <CustomAppBar hideSearch={true} />
                <Box sx={{ bgcolor: 'background.paper', py: 8, px: { xs: 2, sm: 4, md: 6 }, textAlign: 'center' }}>
                    <Typography variant="h2" component="h1" gutterBottom>
                        404
                    </Typography>
                    <Typography variant="h4" component="h2" gutterBottom>
                        Page Not Found
                    </Typography>
                    <Typography variant="body1" paragraph>
                        Oops! The page you're looking for doesn't exist or has been moved.
                    </Typography>
                    <Button variant="contained" color="primary" onClick={() => navigate('/')}>
                        Go to Homepage
                    </Button>
                </Box>
            </Box>
        </Container>
    );
}

export default NotFoundPage;